import React, { useEffect, useState } from 'react'
import UserAttendance from './UserAttendance'
import UserAnnouncement from './UserAnnouncement'
import { useApplyLeave } from '../context/ApplyLeaveContext';
import { useGetApiRequests } from '../../../common/CommonExport';
import dayjs from 'dayjs';
import HolidayAnnouncement from './HolidayAnnouncement';

interface Holiday {
  holidayDetailId: number;
  name: string;
  holidayOn: string;
  description: string | null;
  isActive: boolean;
}




const UserAnnouncementRight = (props: any) => {
  const { announcementList, getAnnouncements } = useApplyLeave()
  const holidayListApi = useGetApiRequests('getHolidayCurrentMonth', 'GET');
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [message, setMessage] = useState<string>('');
  const [activeTab, setActiveTab] = useState<"announcements" | "holidays">(
    "announcements"
  );
  const fetchHolidays = async () => {
    try {
      const nextMonth = dayjs().format("MM-YYYY");

      const response: any = await holidayListApi(
        null,
        {},
        { nextMonth }
      );

      const data = response?.data?.data;
      const Message = response?.data?.status?.message;
      setMessage(Message);

      setHolidays(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error fetching holidays:', err);
    }

  };


  useEffect(() => {
    getAnnouncements()
    fetchHolidays();
  }, [])
  return (
    <section className="space-y-5 h-full">
      <UserAttendance />

      <div className="user-birth-anniversary-bottom  bg-white rounded-lg shadow">

        <div className="flex ">
          <button
            onClick={() => setActiveTab("announcements")}
            className={`flex-1 text-center py-3 font-medium transition-colors duration-200 ${activeTab === "announcements"
              ? "border-b-2 border-pink-500 text-pink-600"
              : "text-gray-500 hover:text-pink-500"
              }`}
          >
            <span className="flex items-center justify-center space-x-1">
              <span className="material-symbols-outlined">campaign</span>
              <span>Announcements</span>
            </span>
          </button>

          <button
            onClick={() => setActiveTab("holidays")}
            className={`flex-1 text-center py-3 font-medium transition-colors duration-200 ${activeTab === "holidays"
              ? "border-b-2 border-pink-500 text-pink-600"
              : "text-gray-500 hover:text-pink-500"
              }`}
          >
            <span className="flex items-center justify-center ">
              <span className="material-symbols-outlined">event</span>
              <span className="ml-1">Holiday List</span>
            </span>
          </button>
        </div>


        <div className=" h-[450px]">
          {activeTab === "announcements" && (
            <UserAnnouncement announcementList={announcementList} />
          )}
          {activeTab === "holidays" && <HolidayAnnouncement holidays={holidays} message={message} />}
        </div>
      </div>
    </section >
  )
}

export default UserAnnouncementRight

